import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataScroller } from "primereact/datascroller";
import { Column } from "primereact/column";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { listaNivel, listaCurso, getListaAsignaturasHorarioCurso, setHorarioConfigInicio, listaBloque, listaProfesores, listaProfesoresHorario, getListaTalleres, listaDiasConfig, registrarHorario, eliminarBloqueHorario, viewPDF, downloadPdfHorarioCurso, downloadPdfHorarioProfesor } from "../../../service/CongifCursoHorario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../actions";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../../utilities/Seguridad";
import { Checkbox } from "primereact/checkbox";
import { Rating } from "primereact/rating";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { SlideMenu } from "primereact/slidemenu";
import { Menu } from 'primereact/menu';
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import classNames from "classnames";
import { OverlayPanel } from "primereact/overlaypanel";
import { VirtualScroller } from "primereact/virtualscroller";
import { Dialog } from "primereact/dialog";
import { isNotVacioNull, isValue, getResultValidar } from "../../../utilities/Validate";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Tooltip } from "primereact/tooltip";
import { parse, stringify, toJSON, fromJSON } from 'flatted';
import { Divider } from 'primereact/divider';

export const PageHorario = () => {
    const dispatch = useDispatch();

    const toast = useRef(null);

    const [niveles, setNiveles] = useState([]);
    const [cursos, setCursos] = useState([]);
    const [bloques, setBloques] = useState([]);
    const [bloquesFilter, setBloquesFilter] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [asignaturas, setAsiganturas] = useState([]);
    const [talleres, setTalleres] = useState([]);

    const [valueNivel, setValueNivel] = useState({});
    const [valueCurso, setValueCurso] = useState({});
    const [cursosFilter, setCursosFilter] = useState([]);

    const [menuBloques, setMenuBloques] = useState([]);

    const [horarios, setHorarios] = useState([]);
    const [checked, setChecked] = useState(false);

    const menu = useRef(null);
    const menuPDF = useRef(null);

    const [horaIniDia, setHoraIniDia] = useState([]);
    const CardDias = useRef([]);
    const selectCardDia = useRef({});
    const [visibleDialog, setVisibleDialog] = useState(false);
    const labelDialog = useRef({ title: "", labelButton: "", editAcceso: {}, visible: false, es_nuevo: false });

    const [profesorPDF, setProfesorPDF] = useState([]);
    const [valueProfesor, setValueProfesor] = useState({});

    //const horaIniDia = useRef({});
    const horaIniDiaCopia = useRef({});
    const rowEditBloque = useRef({});

    const postRegistroHorarioClass = {
        idHorario: "",
        idDiaSem: "",
        idBloque: "",
        inicio: "",
        fin: "",
        idAsigCole: "",
        idProfesional: "",
        idTaller: "",
    };

    const classbloque = {
        hora_fin: "",
        idbloque: null,
        idhorario: null,
        asignatura: "",
        idasigcole: null,
        hora_inicio: "",
        profesional: "",
        tipo_bloque: null,
        idprofesional: null,
        nombre_bloque: "",
    };

    let classCursoTaller = {
        idHorario: null,
        bloque: null,
        asigTaller: null,
        profesores: null,
    };

    let classCursoTallerValidate = {
        idHorario: { estado: null, mensaje: "", validar: isValue, minmax: false },
        bloque: { estado: false, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        asigTaller: { estado: false, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        profesores: { estado: false, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
    };

    const [bloqueData, setBloqueData] = useState(classCursoTaller);
    const [bloqueDataValidate, setBloqueDataValidate] = useState(classCursoTallerValidate);
    const [submitted, setSubmitted] = useState(false);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.mantenedor.asignaturas.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    const loadListaNivel = async () => {
        if (colegio.id !== undefined) {
            let data = await listaNivel(usuario.token);
            setNiveles(data.nivel);
            setValueNivel({})
            setFilterCursos()
        }
    };

    const loadListaCursos = async () => {
        if (colegio.id !== undefined) {
            var data = await listaCurso(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setCursos(data.colegios);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        }
    };

    const setFilterCursos = () => {
        const cursosFil = cursos.filter((o) => o.idnivel == valueNivel.id);
        setCursosFilter(cursosFil);
        setValueCurso({});
        setHorarios([]);
    };

    const loadListaBloques = async () => {
        if (colegio.id !== undefined) {
            var data = await listaBloque(colegio.id, usuario.token);
            if (data.error == 0) {
                setBloques(data.talleres);
                let arrayRecreo = [];
                data.talleres?.map((obj) => {
                    if (obj.tipo == 1) {
                        let o = {
                            label: obj.nombre,
                            data: obj,
                            icon: "pi pi-fw pi-bookmark",
                            command: (event) => {
                                addBloque(event);
                            },
                        };
                        arrayRecreo.push(o);
                    }
                });

                const items = [
                    {
                        label: "Recreo",
                        icon: "pi pi-fw pi-file",
                        tipo: 1,
                        items: arrayRecreo,
                    },
                    {
                        label: "Clases",
                        icon: "pi pi-fw pi-pencil",
                        tipo: 2,
                        command: (event) => {
                            addBloque(event);
                        },
                    },
                    {
                        label: "Taller",
                        icon: "pi pi-fw pi-user",
                        tipo: 3,
                        command: (event) => {
                            addBloque(event);
                        },
                    },
                ];

                setMenuBloques(items);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        }
    }

    const loadListaProfesorColegio = async () => {
        if (colegio.id !== undefined) {
            let rolesData = await listaProfesores(colegio.id, usuario.token);
            //let coleData = await getListaColegio(usuario.token);
            setProfesorPDF(rolesData.profesores);
            setValueProfesor({})
            //setArrayColegio(coleData.colegios);
        }
    }

    const loadListaProfesor = async (es_asignatura, id, view_dialog) => {
        if (colegio.id !== undefined) {
            dispatch(loading(true))
            rowEditBloque.current.viewDialog = view_dialog
            if (id == undefined) {
                setProfesionales([])
            } else {
                let rolesData = await listaProfesoresHorario(es_asignatura, id, colegio.id, usuario.token);
                setProfesionales(rolesData.profesores)
            }
            dispatch(loading(false));
        }
    }

    const loadListaAsignatura = async () => {
        if (colegio.id !== undefined) {
            var data = await getListaAsignaturasHorarioCurso(colegio.id, valueCurso.id, usuario.token);
            //var data = await getListaAsignaturas(colegio.id, 5, usuario.token);
            if (data.error == 0) {
                setAsiganturas(data.asignaturas);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        }
    };

    const loadListaTaller = async () => {
        if (colegio.id !== undefined) {
            var data = await getListaTalleres(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setTalleres(data.talleres);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        }
    };

    const registrarHorarioBloque = async (es_update, tipo, horario) => {
        let validado = {};
        if (tipo == 2 || tipo == 3) {
            setSubmitted(true);
            validado = getResultValidar(bloqueData, bloqueDataValidate);
            setBloqueDataValidate(validado.result);
        } else {
            validado.registra = true;
        }

        if (validado.registra) {
            dispatch(loading(true));

            if (colegio.id !== undefined) {
                var data = await registrarHorario(colegio.id, valueCurso.id, es_update, tipo, horario, usuario.token);
                if (data.error == 0) {
                    toast.current.show({ severity: "success", summary: "OK", detail: "Se registro el Bloque", life: 3000 });
                    loadListaDias()
                    hideDialog()
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
            }
            dispatch(loading(false));
        }
    };

    const loadListaDias = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            var data = await listaDiasConfig(colegio.id, valueCurso.id, usuario.token);
            if (data.error == 0) {
                let dat = {}
                let dat1 = {}
                data.horarios.map((blo) => {
                    dat[blo.dia] = new Date(getFecha() + " " + blo.inicio);
                    dat1[blo.dia] = new Date(getFecha() + " " + blo.inicio);
                });
                setHoraIniDia(dat)
                horaIniDiaCopia.current = dat1;
                setHorarios(data.horarios);

            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    }

    useEffect(() => {
        if (accionPermiso(permisos, "ver")) {
            loadListaNivel();
            loadListaCursos();
            loadListaTaller()
            loadListaProfesorColegio()
        } else {
            history.push("/Acceso");
        }

    }, [anio]);

    useEffect(() => {
        if (valueNivel.id !== undefined) {
            setFilterCursos();
        }
    }, [valueNivel]);

    useEffect(() => {
        if (valueCurso.id !== undefined) {
            loadListaDias();
            loadListaAsignatura();
        }
    }, [valueCurso]);

    useEffect(() => {
        loadListaBloques();
    }, [horarios]);


    useEffect(() => {

        if (stringify(rowEditBloque.current) !== '[{}]' && rowEditBloque.current.viewDialog) {

            let dataEdit = { ...classCursoTaller };
            dataEdit.bloque = rowEditBloque.current.es_nuevo ? {} : bloques?.find((o) => o.id === rowEditBloque.current.row.idbloque)

            if (labelDialog.current.tipo == 2) {
                dataEdit.asigTaller = rowEditBloque.current.es_nuevo ? {} : asignaturas?.find((o) => o.idasigcole === rowEditBloque.current.row.idasigcole);
                dataEdit.profesores = rowEditBloque.current.es_nuevo ? {} : profesionales?.find((o) => o.idprofesional === rowEditBloque.current.row.idprofesional);
            } else {
                dataEdit.asigTaller = rowEditBloque.current.es_nuevo ? {} : talleres?.find((o) => o.id === rowEditBloque.current.row.idtaller);
                dataEdit.profesores = rowEditBloque.current.es_nuevo ? {} : profesionales?.find((o) => o.idprofesional === rowEditBloque.current.row.idprofesional);
            }

            if (rowEditBloque.current.es_nuevo) {
                dataEdit.idHorario = null;
            } else {
                dataEdit.idHorario = rowEditBloque.current.row.idhorario
            }
            setVisibleDialog(true);
            setBloqueData(dataEdit);

        }

    }, [profesionales]);

    const addBloque = (data) => {

        let tipo = data.item.tipo;
        let horarioSelect = selectCardDia.current.card;
        let hora_fin_bloque_anterior = selectCardDia.current.hora_fin;

        if (tipo == 2) {
            viewDialog(true, tipo, data, horarioSelect.dia, "");
        } else if (tipo == 3) {
            viewDialog(true, tipo, data, horarioSelect.dia, "");
        } else {
            let dates = CardDias.current[horarioSelect.dia];
            let ClassReg = { ...postRegistroHorarioClass };
            let duracion = data.item.data.duracion;

            ClassReg.idDiaSem = horarioSelect.iddia;
            ClassReg.idBloque = data.item.data.id;

            // Si hora_fin_bloque_anterior = '' => el click para que visualizar el menu fue desde el boton
            let horaFin = hora_fin_bloque_anterior == "" ? (dates.maxHora == "Invalid Date" ? horaIniDiaCopia.current[horarioSelect.dia] : dates.maxHora) : hora_fin_bloque_anterior;
            let horas = horaFin.getHours().toString();
            let minutos = horaFin.getMinutes().toString();

            ClassReg.inicio = (horas.length == 1 ? "0" + horas : horas) + ":" + (minutos.length == 1 ? "0" + minutos : minutos);

            horaFin.setMinutes(horaFin.getMinutes() + duracion);
            horas = horaFin.getHours().toString();
            minutos = horaFin.getMinutes().toString();

            ClassReg.fin = (horas.length == 1 ? "0" + horas : horas) + ":" + (minutos.length == 1 ? "0" + minutos : minutos);

            registrarHorarioBloque(false, tipo, ClassReg);

            selectCardDia.current.hora_fin = new Date(getFecha() + " " + ClassReg.inicio);
        }
    };

    const onInputChangeNivel = (e) => {
        const val = (e.target && e.target.value) || "";
        setValueNivel(val);
    };

    const onInputChangeCurso = (e) => {
        const val = (e.target && e.target.value) || "";
        setValueCurso(val);
    }

    const onInputChangeProPDF = (e) => {
        const val = (e.target && e.target.value) || "";
        setValueProfesor(val);
    }

    const donwloadPDF = async (tipo) => {

        if (colegio.id !== undefined) {

            dispatch(loading(true));
            var data = {}
            if (tipo == 'curso') {
                data = await downloadPdfHorarioCurso(colegio.id, valueCurso.id, usuario.token);
            } else {
                let ddd = valueProfesor
                data = await downloadPdfHorarioProfesor(colegio.id, valueProfesor.id, usuario.token);
            }

            if (data.error == 0) {
                const buff = Buffer.from(vieHtml(tipo, data.horarios), "utf8");
                await viewPDF(buff.toString("base64"), 'horario.pdf')
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    }

    const vieHtml = (tipo, data) => {
       
        const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes']
        let reg = '';
        for (let i = 0; i < data.length; i++) {
            reg = reg + `<tr><td style="border: 1px solid; padding: 4px 1px 5px 1px;">${i + 1}</td>`
            reg = reg + `<td style="border: 1px solid; padding: 4px 1px 5px 1px;">${data[i].hora_inicio}-${data[i].hora_fin}</td>`
            let bloques = data[i].bloques
            for (let j = 0; j < dias.length; j++) {
                let info = null
                let esRecreo = ''
                for (let k = 0; k < bloques.length; k++) {
                    if (dias[j] === bloques[k]['dia']) {
                        info = bloques[k]
                        if (bloques[k]['tipo_bloque'] == 1) esRecreo = 'background: #95b3d7'
                    }
                }
                reg = reg + `<td style="border: 1px solid; padding: 4px 1px 5px 1px; ${esRecreo}">${info == null ? '' : info.nombre_bloque}</td>`
            }
            reg = reg + `<tr>`
        }

        return `<html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>
        <div style="text-align: center;font-weight: bold;font-family: Arial;font-size: 17px;padding: 10px;">HORARIO DE CLASES</div>
		<span styele="font-weight: bold;font-family: Arial;font-size: 15px;padding: 0px 9px 0px 0px;">${tipo == 'curso' ? 'CURSO:' : 'PROFESOR:'}</span>
        <span styele="font-family: Arial;font-size: 14px;">${tipo == 'curso' ? valueCurso.nombre : valueProfesor.profesional}</span>
        <table style="border-collapse: collapse; width: 100%;text-align: center;font-size: 12px; font-family: Arial;margin-top: 8px;">
        <tbody>
          <tr style="background: #95b3d7;">
            <th style="border: 1px solid; padding: 3px;">Módulo</th>
            <th style="border: 1px solid; padding: 3px; width:85px">Hora</th>
            <th style="border: 1px solid; padding: 3px;">Lunes</th>
            <th style="border: 1px solid; padding: 3px;">Martes</th>
            <th style="border: 1px solid; padding: 3px;">Miércoles</th>
            <th style="border: 1px solid; padding: 3px;">Jueves</th>
            <th style="border: 1px solid; padding: 3px;">Viernes</th>
          </tr>${reg}
        </tbody></table></body></html>`

    }

    const setHoraIniArray = (value, dia) => {
        let dat = { ...horaIniDia }
        dat[dia] = value;
        setHoraIniDia(dat)
    }
    const setHoraIniArray1 = (inicio, dia) => {
        let fechaIn = new Date(getFecha() + " " + inicio);
        let dat = { ...horaIniDia }
        dat[dia] = fechaIn
        setHoraIniDia(dat)
    }

    const setHoraIniArray2 = async (dia) => {
        let dt = horarios[Object.keys(CardDias.current).indexOf(dia)];
        let fe = horaIniDia[dia]
        let horas = fe.getHours().toString();
        let minutos = fe.getMinutes().toString();
        let horaIni = (horas.length == 1 ? "0" + horas : horas) + ":" + (minutos.length == 1 ? "0" + minutos : minutos);

        dispatch(loading(true));
        let data = await setHorarioConfigInicio(horaIni, dt.iddia, valueCurso.id, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se actualizó la hora de Inicio", life: 3000 });
            loadListaDias();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    }

    const eliminar = async (row) => {
        dispatch(loading(true));
        let data = await eliminarBloqueHorario(colegio.id, row.idhorario, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el Bloque", life: 3000 });
            loadListaDias();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    const confirmDelete = (row) => {
        confirmDialog({
            message: "Estas seguro de eliminar el bloque?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminar(row),
        });
    };

    const itemBloque = (bloque, i) => {
        return (
            <div className="p-grid nested-grid p-col-12 p-mb-1 p-mt-1 p-ml-0 p-p-0" style={{ background: "#ffffff", borderRadius: "8px" }}>
                <div className="p-col-10 p-m-0 p-p-0">
                    <div className="p-grid p-m-0">
                        <div className="p-col-6 p-pt-2 p-pb-0 p-pl-3"><Tag className="p-m-0 horaIniFin-bloque-horario" icon="pi pi-clock" value={bloque.hora_inicio}></Tag> </div>
                        <div className="p-col-6 p-pt-2 p-pb-0 p-pl-3"><Tag className="p-m-0 horaIniFin-bloque-horario" icon="pi pi-clock" value={bloque.hora_fin}></Tag></div>
                        <div className="p-col-12 p-pt-2 p-pb-1 p-pl-3 nombre-bloque-horario">{bloque.nombre_bloque}</div>
                        {bloque.profesional == '' ? '' : <div className="p-col-12 p-pt-0 p-pb-1 p-pl-3 nombre-bloque-horario"><span className="pi pi-user p-mr-1" style={{ fontSize: "1em", color: "#7d8194" }}></span><span>{bloque.profesional}</span></div>}
                    </div>
                </div>
                <div className="p-col-2 p-m-0 p-p-2">
                    <Tooltip target=".menu-editar-bloque" mouseTrack mouseTrackLeft={10} />
                    <i className="pi pi-pencil cursor-pointer menu-editar-bloque" data-pr-tooltip="Editar" style={{ cursor: "pointer", color: "#22c55e" }} onClick={() => viewDialog(false, bloque.tipo_bloque, bloque, i.props.id, bloque.hora_fin)}></i>
                    <Tooltip target=".menu-eliminar-bloque" mouseTrack mouseTrackLeft={10} />
                    <i className="pi pi-trash p-mt-2 menu-eliminar-bloque" data-pr-tooltip="Eliminar" style={{ cursor: "pointer", color: "#ef4444" }} onClick={() => confirmDelete(bloque)}></i>
                    <Tooltip target=".menu-add-bloque" mouseTrack mouseTrackLeft={10}>
                        <i className="pi pi-arrow-down"> Insertar bloque </i>
                    </Tooltip>
                    <i className="pi pi-angle-down p-mt-2 menu-add-bloque" style={{ cursor: "pointer", color: "#007bff" }} onClick={(event) => menuCurrent(event, i.props.id, bloque.hora_fin)}></i>
                </div>
            </div>
        );
    };

    const getFecha = () => {
        let nowDate = new Date();
        let nowDay = nowDate.getDate().toString().length == 1 ? "0" + nowDate.getDate().toString() : nowDate.getDate().toString();
        let nowMonth = (nowDate.getMonth() + 1).toString().length == 1 ? "0" + (nowDate.getMonth() + 1).toString() : (nowDate.getMonth() + 1).toString();
        return nowDate.getFullYear() + "-" + nowMonth + "-" + nowDay;
    };

    const menuCurrent = (e, dia, hora_fin) => {
        menu.current.toggle(e);
        selectCardDia.current.card = horarios[Object.keys(CardDias.current).indexOf(dia)];
        selectCardDia.current.hora_fin = hora_fin == "" ? "" : new Date(getFecha() + " " + hora_fin);
    };

    const renderGridItem = (data) => {
        let horaIni = [];
        let horaFin = [];
        let fecha = getFecha();
        // Implementar max hora

        if (data.bloques.length > 0) {
            data.bloques.map((blo) => {
                horaIni.push(new Date(fecha + " " + blo.hora_inicio));
                horaFin.push(new Date(fecha + " " + blo.hora_fin));
            });
        }

        CardDias.current[data.dia] = { dia: data.dia, minHora: new Date(Math.min(...horaIni)), maxHora: new Date(Math.max(...horaFin)) };

        return (
            <div className="card-horarios-dias">
                <div className="product-grid-item card" style={{ height: "calc(70vh - 70px)" }}>
                    <div className="p-grid nested-grid p-col-12 p-mb-1 p-mt-1 p-ml-0 p-p-0">
                        <div className="p-col-7 p-m-0 p-p-0">
                            <div className="p-grid p-m-0">
                                <i className="pi pi-calendar-plus product-category-icon"></i>
                                <span className="product-name">{data.dia}</span>
                            </div>
                        </div>
                        <div className="p-col-5 p-m-0 p-p-0 time-per">
                            <Calendar id={data.iddia} style={{ width: "80px", padding: "0px" }} readOnlyInput={true} value={horaIniDia[data.dia]} onChange={(e) => setHoraIniArray(e.value, data.dia)} timeOnly hourFormat="24" placeholder="HH:MM" />

                            {horaIniDia[data.dia].getTime() != horaIniDiaCopia.current[data.dia].getTime() ? <i className="pi pi-save p-mr-1 p-ml-1" style={{ fontSize: "1.2em", cursor: "pointer", color: "#007bff" }} onClick={(e) => setHoraIniArray2(data.dia)}></i> : ''}
                            {horaIniDia[data.dia].getTime() != horaIniDiaCopia.current[data.dia].getTime() ? <i id={data.iddia} className="pi pi pi-times p-mr-1 p-ml-1" style={{ fontSize: "1.2em", cursor: "pointer", color: "#007bff" }} onClick={(e) => setHoraIniArray1(data.inicio, data.dia)}></i> : ''}

                        </div>
                    </div>


                    <div className="p-mt-2" style={{ textAlign: "center" }}>
                        <SlideMenu ref={menu} effectDuration={500} easing="ease-in" model={menuBloques} popup viewportHeight={160} menuWidth={150}></SlideMenu>

                        <Button type="button" label="Bloque" icon="pi pi-plus" style={{ width: "10rem", padding: "0.5rem" }} badge={data.bloques.length} onClick={(event) => menuCurrent(event, data.dia, "")} />
                    </div>
                    <div className="p-mt-1 virtualscroller-demo-new" style={{ height: "calc(65vh - 130px)" }}>
                        <VirtualScroller id={data.dia} items={data.bloques} itemSize={50} itemTemplate={itemBloque} />
                    </div>
                </div>
            </div>
        );
    };

    const itemTemplate = (data, layout) => {
        if (!data) {
            return;
        }

        return renderGridItem(data);
    };

    const onInputChange = (e, name) => {

        const val = (e.target && e.target.value) || "";
        let _detalla = { ...bloqueData };
        _detalla[`${name}`] = val;
        setBloqueData(_detalla);

        if (labelDialog.current.tipo == 2 && name == "asigTaller") {
            loadListaProfesor(true, val.idasigcole, false);
        }
        if (labelDialog.current.tipo == 3 && name == "asigTaller") {
            loadListaProfesor(false, val.id, false);
        }
    };

    const viewDialog = (es_nuevo, tipo, row, dia, hora_fin) => {

        rowEditBloque.current = {}

        if (hora_fin != "") {
            selectCardDia.current.card = horarios[Object.keys(CardDias.current).indexOf(dia)];
            selectCardDia.current.hora_fin = new Date(getFecha() + " " + hora_fin);
        }

        labelDialog.current.tipo = tipo;
        rowEditBloque.current.row = row
        rowEditBloque.current.es_nuevo = es_nuevo

        let labelTipo = ''

        if (tipo == 2) {
            loadListaProfesor(true, row.idasigcole, true);
            labelTipo = 'Curso'
        } else if (tipo == 3) {
            loadListaProfesor(false, row.idtaller, true)
            labelTipo = 'Taller'
        } else {
            labelTipo = 'Recreo'
        }

        let bloqueFiltroo = bloques?.filter((o) => {
            if (o.tipo == tipo) {
                return o;
            }
        })

        setBloquesFilter(bloqueFiltroo);

        if (es_nuevo) {
            labelDialog.current.title = dia + ": Agregar " + labelTipo;
            labelDialog.current.labelButton = "Registrar";
            labelDialog.current.es_nuevo = true;
        } else {
            labelDialog.current.visible = true;
            labelDialog.current.title = dia + ": Actualizar " + labelTipo;
            labelDialog.current.labelButton = "Actualizar";
            labelDialog.current.es_nuevo = false;
        }

        if (tipo == 1) {
            let dataEdit = { ...classCursoTaller };
            dataEdit.bloque = es_nuevo ? {} : bloques?.find((o) => o.id === row.idbloque)

            if (tipo == 2) {
                dataEdit.asigTaller = es_nuevo ? {} : asignaturas?.find((o) => o.idasigcole === row.idasigcole);
                dataEdit.profesores = es_nuevo ? {} : profesionales?.find((o) => o.idprofesional === row.idprofesional);
            } else {
                dataEdit.asigTaller = es_nuevo ? {} : talleres?.find((o) => o.id === row.idtaller);
                dataEdit.profesores = es_nuevo ? {} : profesionales?.find((o) => o.idprofesional === row.idprofesional);
            }

            if (es_nuevo) {
                dataEdit.idHorario = null;
            } else {
                dataEdit.idHorario = row.idhorario
            }
            setVisibleDialog(true);
            setBloqueData(dataEdit);
        }

    };

    const RegistroCursoTaller = () => {

        let horarioSelect = selectCardDia.current.card;
        let dates = CardDias.current[horarioSelect.dia];
        let hora_fin_bloque_anterior = selectCardDia.current.hora_fin;
        let ClassReg = { ...postRegistroHorarioClass };

        ClassReg.idHorario = bloqueData.idHorario;
        ClassReg.idDiaSem = horarioSelect.iddia;
        ClassReg.idBloque = bloqueData.bloque.id;

        if (labelDialog.current.tipo == 1) {
        } else if (labelDialog.current.tipo == 2) {
            ClassReg.idAsigCole = bloqueData.asigTaller.idasigcole;
            ClassReg.idProfesional = bloqueData.profesores.idprofesional;
        } else {
            ClassReg.idTaller = bloqueData.asigTaller.id;
            ClassReg.idProfesional = bloqueData.profesores.idprofesional;
        }

        if (!labelDialog.current.es_nuevo) {
            hora_fin_bloque_anterior = new Date(getFecha() + " " + rowEditBloque.current.row.hora_inicio)
        }

        // Si hora_fin_bloque_anterior = '' => el click para que visualizar el menu fue desde el boton
        let horaIni = hora_fin_bloque_anterior == "" ? (dates.maxHora == "Invalid Date" ? horaIniDiaCopia.current[horarioSelect.dia] : dates.maxHora) : hora_fin_bloque_anterior;

        let horas = horaIni.getHours().toString();
        let minutos = horaIni.getMinutes().toString();

        ClassReg.inicio = (horas.length == 1 ? "0" + horas : horas) + ":" + (minutos.length == 1 ? "0" + minutos : minutos);

        let horaFin = horaIni;

        horaFin.setMinutes(horaIni.getMinutes() + bloqueData.bloque.duracion);
        horas = horaFin.getHours().toString();
        minutos = horaFin.getMinutes().toString();

        ClassReg.fin = (horas.length == 1 ? "0" + horas : horas) + ":" + (minutos.length == 1 ? "0" + minutos : minutos);

        registrarHorarioBloque(!labelDialog.current.es_nuevo, labelDialog.current.tipo, ClassReg);

        selectCardDia.current.hora_fin = new Date(getFecha() + " " + ClassReg.inicio);
    };

    const hideDialog = () => {
        setVisibleDialog(false);
        labelDialog.current.visible = false;
        setSubmitted(false);
        //setDataMatricula(null);
    };

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={labelDialog.current.labelButton} icon="pi pi-check" onClick={() => RegistroCursoTaller()} />
        </>
    )

    const itemsPDF = [
        {
            label: 'HORARIO PDF',
            items: [
                {
                    label: 'Curso',
                    icon: 'pi pi-file-pdf',
                    disabled: valueCurso.id == undefined,
                    command: () => donwloadPDF('curso')
                },
                {
                    label: 'Profesor',
                    icon: 'pi pi-file-pdf',
                    disabled: !(checked == true && valueProfesor.id !== undefined),
                    command: () => donwloadPDF('profesor')
                }
            ]
        }
    ]

    return (
        <div className="p-grid table-demo">
            <Toast ref={toast} />

            <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0 p-fluid p-mb-2">
                <div className="p-col-12 p-md-3 p-lg-3 p-mt-2">
                    <label htmlFor="name">Nivel:</label>
                    <Dropdown value={valueNivel} onChange={(e) => onInputChangeNivel(e)} options={niveles} optionLabel="nivel" placeholder="::Ingrese Nivel::" />
                </div>
                <div className="p-col-12 p-md-3 p-lg-3 p-mt-2">
                    <label htmlFor="name">Curso:</label>
                    <Dropdown value={valueCurso} onChange={(e) => onInputChangeCurso(e)} options={cursosFilter} optionLabel="nombre" placeholder="::Ingrese Curso::" />
                </div>
                <div className="p-col-12 p-md-1 p-lg-1 p-mt-1"></div>

                <div className="p-col-12 p-md-2 p-lg-2 p-mt-4">
                    <Menu model={itemsPDF} popup ref={menuPDF} id="popup_menu" />
                    <Button label="DESCARGAR" icon="pi pi-download" onClick={(event) => menuPDF.current.toggle(event)} aria-controls="popup_menu" aria-haspopup />
                </div>

                <div className="p-col-12 p-md-3 p-lg-3 p-mt-5" style={{ display: 'flex' }}>
                    <Checkbox inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
                    <Dropdown style={{ marginTop: '-6px', marginLeft: '9px', width: '100%' }} value={valueProfesor} disabled={!checked} onChange={(e) => onInputChangeProPDF(e)} options={profesorPDF} optionLabel="profesional" placeholder="::Ingrese Profesor::" />
                </div>

            </div>
            <Divider />
            <div className="dataview-demo p-fluid" style={{ width: "100%" }}>
                <div className="card p-mt-1 p-p-0">
                    <DataView value={horarios} layout={"grid"} itemTemplate={(e) => itemTemplate(e)} />
                </div>
            </div>

            <Dialog visible={visibleDialog} style={{ width: "40vw" }} breakpoints={{ "960px": "100vw" }} header={labelDialog.current.title} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                    <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                        <label htmlFor="name2">Bloque</label>
                        <Dropdown value={bloqueData.bloque} onChange={(e) => onInputChange(e, "bloque")} options={bloquesFilter} optionLabel="nombre" placeholder="--" />
                        {submitted && !bloqueDataValidate.bloque.estado && <small className="p-error">{bloqueDataValidate.bloque.mensaje}</small>}
                    </div>

                    {labelDialog.current.tipo == 2 ? (
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Clases</label>
                            <Dropdown value={bloqueData.asigTaller} onChange={(e) => onInputChange(e, "asigTaller")} options={asignaturas} optionLabel="alias" placeholder="--" />
                            {submitted && !bloqueDataValidate.asigTaller.estado && <small className="p-error">{bloqueDataValidate.asigTaller.mensaje}</small>}
                        </div>
                    ) : (
                        ""
                    )}

                    {labelDialog.current.tipo == 3 ? (
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Taller</label>
                            <Dropdown value={bloqueData.asigTaller} onChange={(e) => onInputChange(e, "asigTaller")} options={talleres} optionLabel="nombre" placeholder="--" />
                            {submitted && !bloqueDataValidate.asigTaller.estado && <small className="p-error">{bloqueDataValidate.asigTaller.mensaje}</small>}
                        </div>
                    ) : (
                        ""
                    )}

                    {labelDialog.current.tipo == 1 ? (
                        ""
                    ) : (
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">Profesor</label>
                            <Dropdown value={bloqueData.profesores} onChange={(e) => onInputChange(e, "profesores")} options={profesionales} optionLabel="nombre" placeholder="--" />
                            {submitted && !bloqueDataValidate.profesores.estado && <small className="p-error">{bloqueDataValidate.profesores.mensaje}</small>}
                        </div>
                    )}
                </div>
            </Dialog>
        </div>
    );
};
